import { Component, Input } from '@angular/core';
import {
  getGuestPassEligibilityDisplay,
  getGuestPassStatusDisplay,
  GuestPass,
  GuestPassStatus
} from '../../../../../../../../../models/customer';
import { CallbackResult, CallbackResultStatus, dateStringFromISO8601 } from '../../../../../../../../../utils';
import { CustomerService } from '../../../../../../../../../services/customer/customer.service';
import {
  OrganizationConfigService
} from '../../../../../../../../../services/organization-config/organization-config.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-manage-guest-pass-modal',
  templateUrl: './manage-guest-pass-modal.component.html',
  styleUrls: ['./manage-guest-pass-modal.component.css']
})
export class ManageGuestPassModalComponent {
  @Input() guestPass: GuestPass;
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public loadingSubmit = false;

  public serverError: number = null;
  public errorMessage = '';

  public readonly getGuestPassStatusDisplay = getGuestPassStatusDisplay;
  public readonly getGuestPassEligibilityDisplay = getGuestPassEligibilityDisplay;
  public readonly GuestPassStatus = GuestPassStatus;
  public readonly dateStringFromISO8601 = dateStringFromISO8601;

  constructor(
    private customerService: CustomerService,
    public activeModal: NgbActiveModal,
    public orgConfigService: OrganizationConfigService
  ) {}

  public handleRemove() {
    this.loadingSubmit = true;
    this.errorMessage = '';

    if (!confirm('Are you sure you want to remove this guest pass? This action cannot be undone.')) {
      this.loadingSubmit = false;
      return;
    }

    this.customerService
      .removeGuestPass(this.guestPass)
      .then(() => {
        this.savedCallback({
          text: 'Guest pass removed successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to remove this guest pass.';
        } else if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }
}
